import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from '../../grid-view/grid-view.component';
import { GlobalServices } from '../../../services/global.service';
import { MessagingService } from '../../../services/messaging.service';
import { Listing } from '../../../models/listing.model';
import { Languages } from '../../../models/enums.model';
import { DatePipe } from '@angular/common';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { Router } from '@angular/router';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-all-messages',
  templateUrl: './all-messages.component.html'
})
export class AllMessagesComponent implements OnInit {
  isUnread: boolean = true;
  isAdmin:boolean = false;
  public currentUser: User = new User();
  constructor( private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser.IsAdmin){
      this.isAdmin=true;
    }
    else{
      this.isAdmin=false;
    }
  }
  func() {
    if (this.isUnread) {
      this.isUnread=false;
    }
    else
    {
      this.isUnread=true;
    }
  }
  ngOnInit() {
  }
}
